// profile modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import { FRIENDS_DATA, SEND_VERIFY_EMAIL, CHECK_VERIFY_EMAIL, UPDATE_ACCOUNT_INFO, VERIFY_EMAIL_URL, UPDATE_USER_PHOTO, GET_SUBSCRIBE_EMAIL, POST_SUBSCRIBE_EMAIL, PUT_UNSUBSCRIBE_EMAIL, FETCH_PRODUCT_REVIEWS, POST_PRODUCT_REVIEWS, FETCH_PROMOTION_DATA } from '../../api/url'
// initial state
const state = {
  reviewProductsData: [],
  promotionData: [],
  friendsData: [],
}

// actions
const actions = {
  verifyEmail: () => axios({
    url: VERIFY_EMAIL_URL,
    method: 'POST',
    headers: {
      Authorization: `JWT ${getToken()}`,
    },
  }),
  updateUserPhoto: (context, file) => axios({
    url: UPDATE_USER_PHOTO,
    method: 'PUT',
    data: file,
    headers: {
      Authorization: `JWT ${getToken()}`,
    }
  }),
  fetchSubscribeEmail: ({ commit }, data) => axios({ url: `${GET_SUBSCRIBE_EMAIL}?Email=${data}`, method: 'GET'}),
  postSubscribeEmail: ({ commit }, data) => axios({ url: `${POST_SUBSCRIBE_EMAIL}?Email=${data}`, method: 'POST'}),
  putUnsubscribeEmail: ({ commit }, data) => axios({ url: `${PUT_UNSUBSCRIBE_EMAIL}?Email=${data}`, method: 'PUT'}),

  fetchProductReviews(context, productNum) {
    const config = {
      method: 'GET',
      url: `${FETCH_PRODUCT_REVIEWS}`,
      headers: {Authorization: `JWT ${getToken()}`},
    };
    axios(config)
    .then((response) => {
      context.commit('fetchProductReviews', response.data);
    }, (err) => {
      console.log("review fetch error:", err);
    })
  },
  submitProductReviews: ({ commit }, data) => axios({ url: `${POST_PRODUCT_REVIEWS}`, data, method: 'POST', headers: {Authorization: `JWT ${getToken()}`}}),

  fetchPromotionData(context) {
    const config = {
      method: 'GET',
      url: `${FETCH_PROMOTION_DATA}`,
      headers: {Authorization: `JWT ${getToken()}`},
    };
    axios(config)
    .then((response) => {
      context.commit('fetchPromotionData', response.data);
    }, (err) => {
      console.log("promotion fetch error:", err);
    })
  },

  fetchFriendsData(context) {
    const config = {
      method: 'GET',
      url: `${FRIENDS_DATA}`,
      headers: {Authorization: `JWT ${getToken()}`},
    };
    axios(config)
    .then((response) => {
      context.commit('fetchFriendsData', response.data);
    }, (err) => {
      console.log("friends fetch error:", err);
    })
  },

  updateAccountInfo: (context, data) => axios({url: `${UPDATE_ACCOUNT_INFO}`, data, method: 'PUT', headers: {Authorization: `JWT ${getToken()}`}}),
  sendVerifyEmail: (context, data) => axios({url: `${SEND_VERIFY_EMAIL}`, data, method: 'POST', headers: {Authorization: `JWT ${getToken()}`}}),
  checkVerifyEmail: (context, data) => axios({url: `${CHECK_VERIFY_EMAIL}`, data, method: 'POST', headers: {Authorization: `JWT ${getToken()}`}}),
};

// mutations
const mutations = {
  fetchProductReviews(state, payload) {
    state.reviewProductsData = payload;
  },
  fetchPromotionData(state, payload) {
    state.promotionData = payload.promotions;
  },
  fetchFriendsData(state, payload) {
    state.friendsData = payload;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js